import React from 'react';
import './Aurora.css';

export default function Aurora() {
  return (
    <div className="aurora-container">
      <div className="aurora"></div>
    </div>
  );
}
